// extracted by mini-css-extract-plugin
export default {"zameenTopBanner":"index_zameenTopBanner__poH2X"};